import { render, staticRenderFns } from "./BusinessAccounts.vue?vue&type=template&id=64d2e01d"
import script from "./BusinessAccounts.vue?vue&type=script&lang=js"
export * from "./BusinessAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports